import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  registerFinalizeSetIsLoadingReducerType,
  registerFinalizeSetIpAddressReducerType,
  registerFinalizeSetDataReducerType,
  registerFinalizeSetMarketingInfoReducerType,
  registerFinalizeSetFailReducerType,
} from './RegisterFinalizeConstants';

export const initialState = Map({
  data: {
    subjectAreas: undefined,
    userRole: undefined,
    organizationType: undefined,
    organizationName: '',
  },
  ipAddress: null,
  marketingInfo: {
    organizationTypes: [],
    salutations: [],
    subjectAreas: [],
    userAERoles: [],
  },
  isLoading: false,
  registerFinalizeFail: null,
});

const spec = {
  [registerFinalizeSetIpAddressReducerType]: (state, action) => {
    const { ipAddress } = action.payload;
    return state.set('ipAddress', ipAddress);
  },
  [registerFinalizeSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [registerFinalizeSetMarketingInfoReducerType]: (state, action) => {
    const { marketingInfo } = action.payload;
    return state.set('marketingInfo', marketingInfo);
  },
  [registerFinalizeSetDataReducerType]: (state, action) => {
    const currentData = state.get('data');
    return state.set('data', { ...currentData, ...action.payload.data });
  },
  [registerFinalizeSetFailReducerType]: (state, action) => {
    return state.set('registerFinalizeFail', action.payload);
  },
};

export default createReducerBySpec(spec, initialState);
